import { render, staticRenderFns } from "./ScopevisioOrganisationSelector.vue?vue&type=template&id=6efb38f5&scoped=true&"
import script from "./ScopevisioOrganisationSelector.vue?vue&type=script&lang=ts&"
export * from "./ScopevisioOrganisationSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb38f5",
  null
  
)

export default component.exports